import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function FailedSolutions() {
  const solutions = [{
    title: 'Weekend Warrior Workouts',
    desc: "Gym sessions actually cause more injury because you are applying high force to cold, 'stuck' joints."
  }, {
    title: 'Time-Consuming Yoga',
    desc: "Yoga classes are great, but you don't have 60 minutes of free time during a high-pressure work week to drive to a studio."
  }, {
    title: 'Expensive Gadgets',
    desc: "Gadgets and 'supports' are band-aids that ignore the fact that your muscles have forgotten how to support your spine."
  }, {
    title: 'Traditional Stretching',
    desc: 'Often targets the wrong muscles, pulling on your lower back instead of lengthening your hips.'
  }];
  return <section className="w-full bg-dark-panel py-24 border-b border-dark-lighter" data-id="element-17">
      <div className="max-w-5xl mx-auto px-6" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-16 text-center" data-id="element-20">
            Why What You Tried <span className="text-red-500" data-id="element-21">Didn't Work</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-22">
            {solutions.map((item, index) => <div key={index} className="bg-dark p-8 border border-dark-lighter relative overflow-hidden group" data-id="element-23">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-24">
                  <X className="w-24 h-24 text-red-500" data-id="element-25" />
                </div>
                <div className="flex items-start gap-4 relative z-10" data-id="element-26">
                  <div className="mt-1 bg-red-500/10 p-2 rounded-sm" data-id="element-27">
                    <X className="w-6 h-6 text-red-500" data-id="element-28" />
                  </div>
                  <div data-id="element-29">
                    <h3 className="font-display text-2xl uppercase mb-3" data-id="element-30">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed" data-id="element-31">{item.desc}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}